import { createFileRoute } from "@tanstack/react-router";
import Portfolio from "@/pages/Portfolio";
import { industriesQuery, projectsLeanQuery, safePrefetch } from "@/lib/publicQueries";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/portfolio/")({
  loader: async ({ context }) => {
    await Promise.all([
      safePrefetch(context.queryClient, projectsLeanQuery({ publicOnly: true })),
      safePrefetch(context.queryClient, industriesQuery()),
    ]);
  },
  head: () =>
    seoHead({
      title: "Portfolio: Fotos & Videos aus Rhein-Neckar | Clicks DMP",
      description:
        "Ausgewählte Foto- und Videoprojekte aus Mannheim, Heidelberg und der Region: Hotels, Immobilien, Events, Automotive, Musikvideos.",
      path: "/portfolio",
    }),
  component: Portfolio,
});
